export default __webpack_public_path__ + "static/media/VisaCardIcon.ffff2012.svg";